import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "ColorUtils" */ './lazyIndex'),
    { name: 'ColorUtils' }
);

export const lazyGenerateColorScheme: LazyAction<
    typeof lazyIndex.generateColorScheme,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.generateColorScheme);
export const lazyGetOptimalTextColorString: LazyAction<
    typeof lazyIndex.getOptimalTextColorString,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOptimalTextColorString);
